import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { THEME_MESSAGES } from 'utils/constants';
import { getIsNotFound } from 'utils/getIsNotFound';
import { ApiError } from 'types/api';
import { getActivePromotionCount, type ActivePromotionsCountResponse } from 'api/admin/businesses/barry';

export const useGetActivePromotionCount = (businessId: number, enabled: boolean) => {
  return useQuery<unknown, ApiError, ActivePromotionsCountResponse['results']>({
    queryKey: ['activePromotionCount', businessId],
    queryFn: async () => {
      if (!businessId) {
        return null;
      }

      const { data } = (await getActivePromotionCount(
        businessId,
      )) as AxiosResponse<ActivePromotionsCountResponse>;
      return data.results;
    },
    onError: (error) => {
      Sentry.captureException(error);

      if (!getIsNotFound(error)) {
        toast.error(error?.response?.data?.error ?? THEME_MESSAGES.somethingWrong, {
          duration: 4000,
        });
      }
      return error;
    },
    enabled,
  });
};
